import config from './apiConfig';

export default config;
